import { createVNode as d, mergeProps as n } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MetadataManageFilledStandard.js";
import l from "../components/PfIcon.js";
const a = (t, e) => {
  const r = {
    ...t,
    ...e.attrs
  };
  return d(l, n(r, {
    icon: o
  }), null);
};
a.displayName = "MetadataManageFilledStandard";
a.inheritAttrs = !1;
export {
  a as default
};
